import React from "react";
import { managedByAdmin } from "../utils/tenderManagement";
import { usePmsTheme } from "../../Components/PmsThemeContext";
import { getTenderTranslator } from "../pages/tenderMessages";

export default function CorporateRecordBadge({ record, localInventoryPolicy = false }) {
  const { languageId } = usePmsTheme();
  const t = getTenderTranslator(languageId);
  if (!managedByAdmin(record)) return null;
  return <span className="ifm-tag" title={t(localInventoryPolicy ? "Managed by general administration. Inventory policy is set by this business unit." : "Managed by general administration. This record cannot be edited or deleted here.")}>🔒 {t("Corporate")}</span>;
}
